var parent = require('../../es/instance/index-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/index-of.js
// module id = 374
// module chunks = 0 1